import _ from 'lodash';
import Category from "models/Category";
import budgetCalculations from "utilities/budgetCalculations/budgetCalculations";
import DateHelper from "utilities/DateHelper";
import SelectedDates from "utilities/dates/SelectedDates";

export default {
	getTotalAvailableIncludingChildren(budget){
		let total = 0;
		_.each(budget.category.children, (child) => {
			const childBudget = child.getMultiBudget(budget.date);
			total += childBudget.amount;
		});
		total += budget.amount;
		return total;
	},
	getMasterBudgetAmounts(category, budget) {
		let budgetSpent;
		let budgetRemaining;
		let totalBudgeted;
		if(category.is_master_budget_for_children) {
			const transactions = budget.getTransactionsForBudgetIncludingChildren(category);
			budgetSpent = budgetCalculations.getTotalSpentFromTransactions(transactions, category);
			budgetRemaining = this.getTotalAvailableIncludingChildren(budget);
			budgetRemaining = budgetRemaining - budgetSpent;

			totalBudgeted = budget.getBudgeted();
		} else {
			budgetSpent = budget.getSpent();
			budgetRemaining = budget.getRemaining();
			totalBudgeted = budget.getBudgeted();
		}
		return {
			totalBudgeted,
			budgetSpent,
			budgetRemaining,
		};
	},
	getCategorySummaryCalculatedValues(budget, selectedDates, category) {
		let { budgetRemaining, budgetSpent, totalBudgeted } = this.getMasterBudgetAmounts(category, budget);
		let displayedTotalBudgeted = totalBudgeted;
		let displayedBudgetSpent = budgetSpent;

		let isRolloverRemainingAmount = false;

		let canStartRolloverBudget = true;
		let canEndRolloverBudget = false;

		let rolloverBudgets = [];
		let rolloverAmount = 0;
		if(selectedDates) {
			rolloverBudgets = category.getBudgetsRelevantToRollbackPeriod(selectedDates);
			if(rolloverBudgets.length > 0) {
				isRolloverRemainingAmount = true;
				budgetRemaining = 0;
				displayedTotalBudgeted = 0;
				displayedBudgetSpent = 0;
				for(const rolloverBudget of rolloverBudgets) {
					const result = this.getMasterBudgetAmounts(category, rolloverBudget);
					budgetRemaining += result.budgetRemaining;
					displayedTotalBudgeted += result.totalBudgeted;
					displayedBudgetSpent += result.budgetSpent;


					//TODO calculate
					if(budget.contains(rolloverBudget)) {
						rolloverAmount += result.budgetRemaining;
					}
				}
				if(!budget.isRolloverStart()) {
					canEndRolloverBudget = true;
					canStartRolloverBudget = false;
				}
			}
			if(budget.isRolloverEnd()) {
				canEndRolloverBudget = true;
				canStartRolloverBudget = false;
			}
		}
		return {
			budgetSpent,
			budgetAvailable: budgetRemaining,
			totalBudgeted,
			displayedTotalBudgeted,
			displayedBudgetSpent,
			isRolloverRemainingAmount,
			canStartRolloverBudget,
			canEndRolloverBudget,
			rolloverBudgets,
			rolloverAmount,
		};
	}
};